<script>
  import Link from '@commercebear/components/Link';
  import Logo from '$lib/components/Logo';
  import LoginForm from './LoginForm';
  import ForgotPasswordForm from './ForgotPasswordForm';
  import ResetPasswordForm from './ResetPasswordForm';
  import { browser } from '$app/environment';

  export let testid = undefined;
  export let state = 'login';
  export let resetPasswordToken = undefined;

  export let error = undefined;

  let message = { error };

  if (browser) {
    window.history.replaceState({ state, message }, '');
  }

  const gotoState = (s) => (event) => {
    const url = window.location.href.includes('resetpassword') ? '/' : '';
    message = event.detail ?? {};
    state = s;
    window.history.pushState({ state, message }, '', url);
  };

  const handleBack = (event) => {
    ({ state, message } = event.state);
  };
</script>

<div class='login' data-cy={testid}>
  <div class='title'>
    <Link href='https://www.commercebear.com'>
      <Logo />
    </Link>
    <h1 class='login-heading'>Welcome <br> Home.</h1>
  </div>
  <div class='login-form'>
    {#if state === 'login'}
      <LoginForm on:forgot={gotoState('forgotpassword')} on:login={() => window.location.reload()} {...message} />
    {:else if state === 'forgotpassword'}
      <ForgotPasswordForm on:cancel={gotoState('login')} {...message} />
    {:else if state === 'resetpassword'}
      <ResetPasswordForm
        token={resetPasswordToken}
        on:complete={gotoState('login')}
        on:cancel={gotoState('login')}
        on:expired={gotoState('forgotpassword')} />
    {/if}
  </div>
</div>

<svelte:window on:popstate={handleBack} />

<style lang='postcss'>
  .login {
    --Logo--size: 64px;

    display: flex;
    height: 100%;
    overflow-y: scroll;
  }

  .title {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
    padding: 40px 90px 71px 100px;
    background-color: var(--color--secondary-light-green);
    white-space: pre-line;


    & .login-heading {
      color: var(--color--core-white);
      font: var(--font--title-anton-120);
      text-transform: uppercase;
      margin: 0;
      margin-top: 48px;
    }
  }

  .login-form {
    display: flex;
    align-items: flex-end;
    justify-content: stretch;
    box-sizing: border-box;
    padding: 80px;
    width: 640px;
    height: 100%;
    background-color: var(--color--brand-dark-green);
  }

  @media (--screen-width--below-desktop) {
    .login {
      display: flex;
      flex-direction: column;
    }

    .title {
      padding: 40px 80px 80px 80px;

      & .login-heading {
        font: var(--font--title-anton-100);
      }
    }

    .login-form {
      width: 100%;
      max-height: 476px;
      height: min-content;
      align-items: unset;
    }
  }

  @media (--screen-width--below-tablet) {
    .login {
      --Logo--size: 40px;
    }

    .title {
      height: 320px;
      box-sizing: border-box;
      flex-grow: unset;
      padding: 16px 24px 80px 24px;

      & .login-heading {
        font: var(--font--title-anton-60);
      }
    }  

    .login-form {
      flex-grow: 1;
      max-height: unset;
      padding: 40px 24px;
    }
  }
</style>
